"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NINETY_NINE_PERCENT = exports.MAX_UINT256 = exports.BASE = exports.ONE_YEAR_IN_SECONDS = exports.FIVE_PERCENT = exports.TEN_PERCENT = void 0;
var ethers_1 = require("ethers");
exports.TEN_PERCENT = ethers_1.BigNumber.from(3022265980);
exports.FIVE_PERCENT = ethers_1.BigNumber.from(1547125957);
exports.ONE_YEAR_IN_SECONDS = ethers_1.BigNumber.from(31536000);
exports.BASE = ethers_1.BigNumber.from(10).pow(18);
exports.MAX_UINT256 = ethers_1.BigNumber.from(2).pow(255);
exports.NINETY_NINE_PERCENT = ethers_1.BigNumber.from(21820606489);
//# sourceMappingURL=constants.js.map